export const LOAD_INITIAL_HTML_STARTUP_DATA =
  'APP_LOAD_INITIAL_HTML_STARTUP_DATA'

export const loadInitialHtmlStartupData = htmlStartupData => ({
  type: LOAD_INITIAL_HTML_STARTUP_DATA,
  htmlStartupData
})
